import { Col, Row } from 'antd';
import { useTranslation } from 'react-i18next';
import CompanyCurrencyField from '../../../../components/fields/CompanyCurrencyField';
import CollapsibleWrapper, { Panel } from '../../../../components/wrappers/CollapsibleWrapper';
import FormFields from '../../../../themes/admin/Fields/FormFields';
import useFormattedSimpleVersioning from '../../../../utilities/useFormattedSimpleVersioning';
import { useVariantConfigurator } from '../VariantConfiguratorContext';

const colSpan = { md: 8, sm: 12, xs: 24 };
const VariantConfiguratorDetailsForm = ({ disabled = false }: { disabled?: boolean }) => {
    const { t } = useTranslation(['variantConfiguratorDetails', 'common']);

    const { variantConfigurator } = useVariantConfigurator();
    const { updated, offset } = useFormattedSimpleVersioning({
        versioning: variantConfigurator.versioning,
        timeZone: variantConfigurator.company.timeZone,
    });

    return (
        <CollapsibleWrapper defaultActiveKey={t('variantConfiguratorDetails:sections.details.label')}>
            <Panel
                key={t('variantConfiguratorDetails:sections.details.label')}
                header={t('variantConfiguratorDetails:sections.details.label')}
            >
                <Row gutter={14}>
                    <Col {...colSpan}>
                        <CompanyCurrencyField
                            {...t('variantConfiguratorDetails:fields.vehiclePrice', {
                                returnObjects: true,
                            })}
                            company={variantConfigurator.company}
                            disabled={disabled}
                            name="vehiclePrice"
                            required
                        />
                    </Col>
                    <Col {...colSpan}>
                        <FormFields.DisplayFieldWithUTCOffset
                            {...t('common:fields.updated', { returnObjects: true, offset })}
                            value={updated}
                        />
                    </Col>
                </Row>
            </Panel>
        </CollapsibleWrapper>
    );
};

export default VariantConfiguratorDetailsForm;
